import { useAuthentication } from '~/composables/auth/useAuthentication'
import { useOAuth } from '~/composables/auth/useOAuth'

const isAutoLoggedOut = ref<boolean>(false)
let handling = false

interface UseSessionExpiryReturn {
  isAutoLoggedOut: Readonly<Ref<boolean>>
  triggerSessionExpired: (opts?: { silent?: boolean }) => void
}

export const useSessionExpiry = (): UseSessionExpiryReturn => {
  const authStore = useAuthStore()
  const { logUserOut } = useAuthentication()
  const oauth = useOAuth()

  const triggerSessionExpired = (opts?: { silent?: boolean }): void => {
    if (handling) return
    handling = true

    if (opts?.silent || !authStore.isAuthenticated || !authStore.activeLicence) {
      logUserOut()
      navigateTo(oauth.buildRedirectUrl('logout'), { external: true })
      return
    }

    isAutoLoggedOut.value = true
    localStorage.setItem('pending_oauth_logout', '1')
    logUserOut()
  }

  return {
    isAutoLoggedOut: readonly(isAutoLoggedOut),
    triggerSessionExpired
  }
}
